import { useEffect, useRef, useState } from "react";

/**
 * Forces a loading state to stay true for at least `minMs`,
 * so the loader never just flashes on fast connections.
 *
 * Usage:
 *   const loading = useMinimumLoading(actuallyLoading); // defaults to 2000ms
 *   if (loading) return <Loader />;
 */
export default function useMinimumLoading(isLoading, minMs = 2000) {
  const [minTimeElapsed, setMinTimeElapsed] = useState(false);
  const startRef = useRef(Date.now());

  useEffect(() => {
    startRef.current = Date.now();
    setMinTimeElapsed(false);

    const timer = setTimeout(() => setMinTimeElapsed(true), minMs);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // only run once, on mount of whatever calls this

  return isLoading || !minTimeElapsed;
}